function formatCountdown(distance) {
	var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	var seconds = Math.floor((distance % (1000 * 60)) / 1000);

	return '<span>' + days + 'd</span> <span>' + hours + 'h</span> <span>' + minutes + 'm</span> <span>' + seconds + 's</span>';
}

function parseDateAsEST(dateValue) {
	if (!dateValue) {
		return NaN;
	}

	var normalizedDate = String(dateValue).trim().replace(' ', 'T');
	var hasTimeZone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(normalizedDate);

	if (!hasTimeZone) {
    // If the date string does not include a timezone, assume it's in EST (UTC-5)
		normalizedDate += '-05:00';
	}

	return new Date(normalizedDate).getTime();
}

function initCountdownTimers(root) {
	var scope = root || document;
	var timers = [];

	if (scope.nodeType === Node.ELEMENT_NODE && scope.matches('[data-countdown-date]')) {
		timers.push(scope);
	}

	timers = timers.concat(Array.from(scope.querySelectorAll('[data-countdown-date]')));

	timers.forEach(function (timerElement) {
		if (timerElement.dataset.countdownInitialized === 'true') {
			return;
		}

		var dateValue = timerElement.dataset.countdownDate;
		var targetTime = parseDateAsEST(dateValue);

		if (Number.isNaN(targetTime)) {
			return;
		}

		var expiredText = timerElement.dataset.countdownExpiredText || 'Available now!';

		function updateCountdown() {
			var now = new Date().getTime();
			var distance = targetTime - now;

			if (distance < 0) {
				timerElement.innerHTML = expiredText;
				clearInterval(intervalId);
				return;
			}

			timerElement.innerHTML = formatCountdown(distance);
		}

		updateCountdown();
		var intervalId = setInterval(updateCountdown, 1000);
		timerElement.dataset.countdownInitialized = 'true';
	});
}

function observeDynamicCountdowns() {
	if (!document.body || typeof MutationObserver === 'undefined') {
		return;
	}

	var observer = new MutationObserver(function (mutationsList) {
		mutationsList.forEach(function (mutation) {
			mutation.addedNodes.forEach(function (addedNode) {
				if (addedNode.nodeType !== Node.ELEMENT_NODE) {
					return;
				}

				if (addedNode.matches('[data-countdown-date]') || addedNode.querySelector('[data-countdown-date]')) {
					initCountdownTimers(addedNode);
				}
			});
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

window.initCountdownTimers = initCountdownTimers;

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initCountdownTimers(document);
		observeDynamicCountdowns();
	});
} else {
	initCountdownTimers(document);
	observeDynamicCountdowns();
}
